<template>
    <b-row>
      <b-col cols="12">
        <b-row class="mt-4">
          <b-col>
              Here’s what’s included: 
            <p class="mb-0"><i class="mdi mdi-18px mdi-check"></i>Access to specialty-specific compensation and productivity data to inform your offer.</p>
            <p class="mb-0"><i class="mdi mdi-18px mdi-check"></i>Immediate delivery of your job opportunity to all interested candidates.</p>
            <p class="mb-0"><i class="mdi mdi-18px mdi-check"></i>Our algorithm searches for and includes any new matching candidates for  {{ this.job_opportunity_duration }} days.</p>
            <p class="mb-0"><i class="mdi mdi-18px mdi-check"></i>Instant candidate feedback and communications delivered to your Dashboard.</p>
            <p class="mb-0"><i class="mdi mdi-18px mdi-check"></i>All for ${{ this.job_opportunity_price}}. <a href="mailto:pricinginfo@Phairify.com"><u>Contact us</u></a> for special early adopter pricing.</p>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col>
              How would you like to pay?
            <!-- <p class="mt-4">
                (Invoicing available only for Customers that have confirmed their billing 
                information under separate agreement.)
            </p> -->
        </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col class="display-flex justify-content-space-between max-width-in-per m-0-auto">
                <label>
                  Credit Card <input type="radio" v-model="selectedOption" value="card" @change="handleChange"> 
                </label>
                <label>
                  Invoice <input type="radio" v-model="selectedOption" value="invoice" @change="handleChange"> 
                </label>
          </b-col>
        </b-row>
    </b-col>
    </b-row>
</template>
  
  <script>
  import Api from '@/providers/Api';
  
  export default {
    name: 'PurchaseSelection',
    data() {
        return {
            selectedOption: null,
            job_opportunity_duration:0,
            job_opportunity_price: 0,
        };
    },
    mounted: async function () {
    const jobOpportunityDuration = await Api.getSettingByKey('job_opportunity_duration');
    this.job_opportunity_duration = jobOpportunityDuration.value ? jobOpportunityDuration.value : 90;
    const jobOpportunityPrice = await Api.getSettingByKey('job_opportunity_price');
    this.job_opportunity_price = jobOpportunityPrice.value ? jobOpportunityPrice.value : 500;
  },
    methods: {
      handleChange() {
        this.$emit('payment-method', this.selectedOption);
        }
    }
  };
  </script>
  
  <style scoped lang="scss">
  @import '../../../../sass/variables_mixins.scss';
  .v2_bg_primary_teal {
    background-color: $phairify_v2_color_primary_teal;
  }
  .btn-next{
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    max-height: 30px;
    font: normal normal 550 16px/24px;
    letter-spacing: 0;
    color: #00586f !important;
    background-color: #99c555 !important;
    border: 1px solid #00586f !important;
    opacity: 1;
    max-width: 180px;
      width: 100%;
      justify-content: center;
      margin: 10px;
    border-radius: 0;
  }
  .btn-next:hover{
    background-color: #b0d27b !important;
  }
  .btn-next i{
    font-size:15px;
  }
  .btn-next:disabled{
    background-color:#DEE9EC !important;
    outline-color:rgba(77,88,88,0.5);
    border:1px solid #00586f !important;
    cursor: not-allowed;
  }
  .post_opportunity_btn{
    display: flex;
    align-items: center;
    flex-flow: column;
    height: unset;
  }
  .post_opportunity_btn p {
    line-height: 18px;
    margin-bottom: 0;
    padding-top: 20px;
  }
  .max-height-150{
      max-height: 150px;
  }
  .margin-30{
    margin: 30px;
  }
  .mt-10{
    margin-top:10px;
  }
  .max-width-in-per {
    max-width: 35%;
  }
  .m-0-auto{
    margin: 0 auto;
  }
  .justify-content-space-between{
    justify-content: space-between;
  }
  @media (max-width:767px){
    .max-width-in-per {
      max-width: 100%;
    }
  }
  @media (max-width:1024px){
    .max-width-in-per {
      max-width: 70%;
    }
  }
  </style>
  